import type {BioIconProps} from './common-types'

function Icon({...attributes}: BioIconProps) {
  return (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M4.70923e-06 3.34163C0.0179113 1.49304 1.52202 0 3.37484 0C4.43507 0 5.38111 0.488876 5.99985 1.2535C6.61858 0.488876 7.56462 0 8.62484 0C10.4888 0 11.9998 1.51104 11.9998 3.375C11.9998 3.42155 11.9989 3.46792 11.997 3.51409C11.9333 5.64751 10.3783 7.2732 9.04154 8.29795C8.35219 8.8264 7.67032 9.23401 7.16274 9.5091C6.90808 9.6471 6.69512 9.75292 6.54414 9.82497C6.4686 9.86102 6.40843 9.88869 6.36614 9.90777C6.34499 9.91732 6.3283 9.92472 6.31638 9.92996L6.30212 9.93619L6.29775 9.93808L6.29626 9.93872C6.11 10.02 5.89 10.02 5.70405 9.93899L5.70197 9.93809L5.69752 9.93617L5.683 9.92982C5.67087 9.92449 5.65386 9.91695 5.63231 9.90722C5.58923 9.88777 5.52792 9.85957 5.45097 9.82282C5.29719 9.74936 5.08035 9.64146 4.82137 9.50075C4.3052 9.22031 3.61264 8.80468 2.91574 8.26587C1.5637 7.22054 -0.000895857 5.55828 -0.000976562 3.38003C-0.000976562 3.36719 -0.000648379 3.35439 4.70923e-06 3.34163Z"
        fill="#1E40AF"
      />
    </svg>
  )
}

export const HeartIcon = Icon
